module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": true,
      "width": "1300px",
      "normal-width": "90vw",
      "set-class": "no-padding-mobile"
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.unit) ? _c('div', {}) : _vm._e()])]), _vm._v(" "), (_vm.unit && _vm.open) ? _c('div', {
    class: 'modal-content active-tab-' + _vm.activeTab
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h1",
    class: {
      'has-subtitle': _vm.unit.subtitle
    }
  }, [_c('h1', [_vm._v("\n        " + _vm._s((_vm.unit.display_name || _vm.unit.description_title)) + "\n        "), (_vm.unit.subtitle) ? _c('i', [_vm._v(_vm._s(_vm.unit.subtitle))]) : _vm._e()])]), _vm._v(" "), (_vm.confirmedAccomodations.length && !_vm.editing) ? _c('div', {
    staticClass: "multiple-accomodations"
  }, [_vm._v("\n      Du har redan ett boende i varukorgen. Om du vill boka flera boenden i samma bokning måste du välja samma datum ("), _c('span', [_vm._v(_vm._s(_vm._f("dateRange")([_vm.confirmedAccomodations[0].period.date_arrival, _vm.confirmedAccomodations[0].period.date_departure], 'D MMMM', ' - ')))]), _vm._v(").\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'calendar-periods': true
    }
  }, [_c('div', {
    staticClass: "calendar-header center"
  }, [_c('div', [_c('label', {
    staticClass: "calendar-helper-text min-desktop"
  }, [_c('icon', {
    attrs: {
      "name": "calendar-blue",
      "scale": 2
    }
  }), _c('br'), _vm._v("\n            Öppna kalendervy för:\n          ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "calendar-buttons"
  }, [(this.validStartDatesWinter.length) ? _c('OutlineButton', {
    staticClass: "filter-bt",
    class: {
      active: _vm.winterCalendarOpen
    },
    style: ('order: ' + _vm.getButtonOrderFor('winter')),
    attrs: {
      "label": _vm.getButtonLabelFor('winter'),
      "closeLabel": _vm.getButtonLabelFor('winter'),
      "icon": "skiing",
      "iconscale": 2.5,
      "status": _vm.winterCalendarOpen
    },
    on: {
      "clicked": _vm.toggleWinterCalendar
    }
  }) : _vm._e(), _vm._v(" "), (this.validStartDatesSummer.length) ? _c('OutlineButton', {
    staticClass: "filter-bt",
    class: {
      active: _vm.summerCalendarOpen
    },
    style: ('order: ' + _vm.getButtonOrderFor('summer')),
    attrs: {
      "label": _vm.getButtonLabelFor('summer'),
      "closeLabel": _vm.getButtonLabelFor('summer'),
      "icon": "biking",
      "iconscale": 2.5,
      "status": _vm.summerCalendarOpen
    },
    on: {
      "clicked": _vm.toggleSummerCalendar
    }
  }) : _vm._e(), _vm._v(" "), (this.validStartDatesNextWinter.length) ? _c('OutlineButton', {
    staticClass: "filter-bt",
    class: {
      active: _vm.nextWinterCalendarOpen
    },
    style: ('order: ' + _vm.getButtonOrderFor('next_winter')),
    attrs: {
      "label": _vm.getButtonLabelFor('next_winter'),
      "closeLabel": _vm.getButtonLabelFor('next_winter'),
      "icon": "skiing",
      "iconscale": 2.5,
      "status": _vm.nextWinterCalendarOpen
    },
    on: {
      "clicked": _vm.toggleNextWinterCalendar
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    class: {
      calendar: true, opened: _vm.winterCalendarOpen
    }
  }, [_c('DatepickerRangeModal', {
    attrs: {
      "params": {
        componentType: 'ModalFaker',
        clickOutside: false,
        validDates: this.validStartDatesWinter,
        disabledDays: this.disabledDays,
        specialDays: this.specialDays,
        onPickStart: this.updateEndDate,
        pickedStartDate: null,
        pickedEndDate: null,
        terminology: 'Välj',
        onClose: this.onPicked,
        infoOnPicked: 'Välj slutdatum',
        info: 'Välj vilken dag du vill bo från',
        disableSingle: true,
        open: this.SITE_CONFIG.modules_open.accomodation.open,
        closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
        startMonth: this.startMonth('winter')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      calendar: true, opened: _vm.summerCalendarOpen
    }
  }, [_c('DatepickerRangeModal', {
    attrs: {
      "params": {
        componentType: 'ModalFaker',
        clickOutside: false,
        validDates: this.validStartDatesSummer,
        disabledDays: this.disabledDays,
        specialDays: this.specialDays,
        onPickStart: this.updateEndDate,
        pickedStartDate: null,
        pickedEndDate: null,
        terminology: 'Välj',
        onClose: this.onPicked,
        infoOnPicked: 'Välj slutdatum',
        info: 'Välj vilken dag du vill bo från',
        disableSingle: true,
        open: this.SITE_CONFIG.modules_open.accomodation.open,
        closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
        startMonth: this.startMonth('summer')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      calendar: true, opened: _vm.nextWinterCalendarOpen
    }
  }, [_c('DatepickerRangeModal', {
    attrs: {
      "params": {
        componentType: 'ModalFaker',
        clickOutside: false,
        validDates: this.validStartDatesNextWinter,
        disabledDays: this.disabledDays,
        specialDays: this.specialDays,
        onPickStart: this.updateEndDate,
        pickedStartDate: null,
        pickedEndDate: null,
        terminology: 'Välj',
        onClose: this.onPicked,
        infoOnPicked: 'Välj slutdatum',
        info: 'Välj vilken dag du vill bo från',
        disableSingle: true,
        open: this.SITE_CONFIG.modules_open.accomodation.open,
        closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
        startMonth: this.startMonth('next_winter')
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "max-tablet"
  }, [_c('div', {
    staticClass: "tabs-header center"
  }, [_c('label', [_vm._v("Välj period")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [(_vm.unit.prices_special_length) ? _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'special' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('special')
      }
    }
  }, [_c('div', [_vm._v("Populära perioder 2025/26")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.meta_super_titles), function(value, index) {
    return _c('div', {
      class: [
        'tab',
        _vm.activeTab === (index + 1) && 'active' ],
      on: {
        "click": function($event) {
          return _vm.setTab(index + 1)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(value))])])
  })], 2)]), _vm._v(" "), (_vm.unit.prices_special_length) ? _c('div', {
    staticClass: "special-periods"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        Populära perioder 2025/2026\n      ")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "title-row week-title-row"
  }, [_c('th', [_c('b', [_vm._v(" ")])]), _vm._v(" "), _c('th', [_vm._v("\n            Datum\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Pris\n          ")])]), _vm._v(" "), _vm._l((_vm.sortedSpecialPrices), function(price) {
    return _c('tr', [_c('td', [_c('b', {
      domProps: {
        "innerHTML": _vm._s(price.title)
      }
    }), _vm._v(" "), (price.notes) ? _c('div', {
      staticClass: "smaller"
    }, [_vm._v(_vm._s(price.notes))]) : _vm._e()]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(price.days)
      }
    }), _vm._v(" "), _c('td', {
      class: {
        notvalid: _vm.validPeriod && (price.period && (price.period.date_arrival + '-' + price.period.date_departure) != _vm.validPeriod)
      }
    }, [(price.period.free) ? _c('span', {
      class: {
        price: true,
          selected: (_vm.cartAccomodationObject && _vm.cartAccomodationObject.period && (_vm.cartAccomodationObject.unitLid == _vm.unit.unit_lid && _vm.cartAccomodationObject.poolLid == _vm.unit.pool_lid) && _vm.cartAccomodationObject.period.period == price.period.period && _vm.cartAccomodationObject.period.week == price.period.week)
      },
      on: {
        "click": function($event) {
          _vm.chooseAccomodation({
            pool_lid: _vm.unit.pool_lid,
            unit_lid: _vm.unit.unit_lid,
            period: price.period,
            week: price.period.week,
            name: (_vm.unit.display_name || _vm.unit.description_title),
            capacity: _vm.unit.capacity,
            price: price.period.price
          })
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(price.period.price)) + "\n            ")]) : _vm._e(), _vm._v(" "), (!price.period.free) ? _c('span', {
      staticClass: "taken"
    }, [_vm._v("\n              -\n            ")]) : _vm._e()])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.unit.prices_length) ? _c('div', {
    class: {
      'normal-periods': true, 'no-specials': !_vm.unit.prices_special_length
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        PRISÖVERSIKT VINTER 2025/2026\n      ")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "title-row"
  }, [_c('th'), _vm._v(" "), _vm._l((_vm.meta_super_titles), function(meta, index) {
    return (meta) ? _c('th', {
      class: 'period-super-title',
      attrs: {
        "colspan": _vm.meta_super_titles_colspan[index]
      }
    }, [_vm._v("\n            " + _vm._s(meta) + "\n          ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "title-row week-title-row"
  }, [_c('th', {
    staticClass: "week-indicator"
  }, [_c('b', [_vm._v("Vecka")])]), _vm._v(" "), _vm._l((_vm.meta_periods), function(period, index) {
    return _c('th', {
      class: 'week-day-title index-' + _vm.belongsToCol(index)
    }, [_vm._v("\n            " + _vm._s(period.days) + "\n          ")])
  })], 2), _vm._v(" "), _vm._l((_vm.unit.prices), function(week, index) {
    return (index >= _vm.meta_weeks[0] && index <= _vm.meta_weeks[1]) ? _c('tr', [_c('td', {
      staticClass: "week-indicator",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('b', [_vm._v("v." + _vm._s(week.week))]), _vm._v(" "), _c('popper', {
      attrs: {
        "trigger": "click",
        "options": {
          placement: 'right'
        }
      }
    }, [_c('div', {
      staticClass: "popper"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.showDates(week.periods))
      }
    })]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_vm._v("\n                Datum\n              ")])])], 1), _vm._v(" "), _vm._l((week.periods), function(period, key, index) {
      return _c('td', {
        class: (_vm.validPeriod && (period && (period.date_arrival + '-' + period.date_departure) != _vm.validPeriod) ? 'notvalid' : '') + ' p index-' + _vm.belongsToCol(index)
      }, [(period && period.free && !period.hide && !period.note) ? _c('span', {
        class: {
          price: true,
            selected: (_vm.cartAccomodationObject && _vm.cartAccomodationObject.period && (_vm.cartAccomodationObject.unitLid == _vm.unit.unit_lid && _vm.cartAccomodationObject.poolLid == _vm.unit.pool_lid) && _vm.cartAccomodationObject.period.period == period.period && _vm.cartAccomodationObject.period.week == period.week)
        },
        on: {
          "click": function($event) {
            _vm.chooseAccomodation({
              pool_lid: _vm.unit.pool_lid,
              unit_lid: _vm.unit.unit_lid,
              period: period,
              week: week.week,
              name: (_vm.unit.display_name || _vm.unit.description_title),
              capacity: _vm.unit.capacity,
              price: period.price
            })
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(period.price)) + "\n            ")]) : _vm._e(), _vm._v(" "), (period && !period.free && !period.hide && !period.note) ? _c('span', {
        staticClass: "taken"
      }, [_vm._v("\n              -\n            ")]) : _vm._e(), _vm._v(" "), (period && period.note) ? _c('span', {
        staticClass: "price-note"
      }, [_vm._v("\n              *\n            ")]) : _vm._e(), _vm._v(" "), (!period) ? _c('span', {
        staticClass: "taken"
      }, [_vm._v("\n              -\n            ")]) : _vm._e()])
    })], 2) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.unit.prices_length && !_vm.unit.prices_special_length && !_vm.unit.prices_summer_length) ? _c('div', [_c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Det går för tillfället inte att visa några priser eller lediga perioder för detta boende. Kom tillbaka snart eller ring gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "margin-top": "15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.notes) ? _c('div', {
    staticClass: "info-transparent"
  }, _vm._l((_vm.notes), function(note) {
    return _c('div', [_c('b', [_vm._v("*")]), _vm._v(" " + _vm._s(note) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), ((_vm.unit.tags || []).indexOf('SATURDAY_ACCOMMODATION') !== -1 && _vm.SITE_CONFIG.settings.SettingAccommodationPriceViewInfo) ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.settings.SettingAccommodationPriceViewInfo)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_limit_text) ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_limit_text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.special_info1) ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.special_info1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.closed_slopes) ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.closed_slopes)
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.open) ? _c('div', [_c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v(_vm._s(_vm.closedMessage))])])]) : _vm._e(), _vm._v(" "), (false) ? _c('pre', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70a6a688"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Accomodation/AccomodationsPagePrice.vue
// module id = 974
// module chunks = 0